import PDFIcon from '../../static/utils/pdf-icon.svg'
import React, {useState} from 'react'
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack'
import PDF from '../../static/sample.pdf'
import Icon from '../../ui-kit/components/atoms/Icon'
import {SAVE_ICON} from '../../ui-kit/helpers/icons/save'
import DeleteButton from '../atoms/buttons/DeleteButton'

const PublicationFile = ({file, showPreview, editMode}) => {
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({numPages}) {
    setNumPages(numPages)
  }

  const createFileName = () => {
    const arrayName = file.split('/')
    return arrayName[arrayName.length - 1]
  }

  // TODO
  // Cambiar la variable PDF por los verdaderos archivos cuando ya se encuentren en el mismo dominio

  return (
    <article className="pdf-file">
      {editMode && <DeleteButton title="Borrar PDF" />}
      <header className="pdf-header">
        <div className="title">
          <img src={PDFIcon} alt="PDF Icon" />
          <p title={createFileName()} className="text">
            {createFileName()}
          </p>
        </div>
        {showPreview ? (
          <a
            title="Descargar documento"
            href={PDF}
            download
            className="button light small"
          >
            Descargar
          </a>
        ) : (
          <a
            title="Descargar documento"
            href={PDF}
            download
            className="action-button blue"
          >
            <Icon className="icon" svg={SAVE_ICON} />
          </a>
        )}
      </header>
      {showPreview && (
        <Document file={PDF} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
      )}
    </article>
  )
}

export default PublicationFile
